import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import { useEffect } from 'react';
import {
  LocationCodesSelectors,
  LocationCodesThunks,
} from './redux/locationCodes';
import { OptionType } from '../../types/LocationCodes';

export const useLocationCodes = () => {
  const dispatch = useAppDispatch();

  const countryOptions = useAppSelector(
    LocationCodesSelectors.selectCountriesOptions,
  );
  const cityOptions = useAppSelector(
    LocationCodesSelectors.selectCitiesOptions,
  );
  const cityAndZipCodeOptions = useAppSelector(
    LocationCodesSelectors.selectCitiesAndZipCodesOptions,
  );
  const nationalityOptions = useAppSelector(
    LocationCodesSelectors.selectNationalitiesOptions,
  );

  useEffect(() => {
    if (!countryOptions || !nationalityOptions) {
      dispatch(LocationCodesThunks.fetchCountries());
    }
    if (!cityOptions || !cityAndZipCodeOptions) {
      dispatch(LocationCodesThunks.fetchCitiesByCountryCode('HR'));
    }
  }, [
    countryOptions,
    nationalityOptions,
    cityOptions,
    cityAndZipCodeOptions,
    dispatch,
  ]);

  const findCountryByIsoCode = (isoCode?: string) =>
    countryOptions?.find((country) => country.value === isoCode)?.label;

  const findCityByGemicroCode = (gemicroCode?: string) =>
    cityAndZipCodeOptions
      ?.find((city: OptionType) => city.value === gemicroCode)
      ?.label.toUpperCase();

  return {
    countryOptions: countryOptions || [],
    cityAndZipCodeOptions: cityAndZipCodeOptions || [],
    cityOptions: cityOptions || [],
    nationalityOptions: nationalityOptions || [],
    findCityByGemicroCode,
    findCountryByIsoCode,
  };
};
